/* eslint-disable */

/* Font Awesome imports */
import '@fortawesome/fontawesome-pro/css/fontawesome.css';
import '@fortawesome/fontawesome-pro/css/light.css';
import '@fortawesome/fontawesome-pro/css/brands.css';
import '@fortawesome/fontawesome-pro/css/solid.css';
import '@fortawesome/fontawesome-pro/css/regular.css';

// "async" is optional
export default async (
    {
        /* app, router, Vue, ... */
    }
) => {
    // something to do
};
